import { WbText } from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from '../../../i18n/useTranslation';
import { validationUtils } from '../../../../utils/validationFunctions';

const useStyles = makeStyles()(() => ({
    italic: {
        fontStyle: 'italic',
    },
}));

interface BeamSelectAsTextProps {
    value?: string;
    showValueAsText?: boolean;
    isBeamFree?: boolean;
}

const BeamSelectAsText = ({ value, showValueAsText, isBeamFree }: BeamSelectAsTextProps) => {
    const { classes } = useStyles();
    const translate = useTranslation();
    if (showValueAsText || isBeamFree) {
        return (
            <WbText className={value ? '' : classes.italic}>
                {validationUtils.isValidOrEmptyText(value) ? value : translate('no_data_entered')}
            </WbText>
        );
    }
    return null;
};

export default BeamSelectAsText;
